import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const siteKey = '6LcJm6QrAAAAABClCY7MpfQvSGhxxy0n1MCUjH_R'; // Clé reCAPTCHA
const Url = process.env.REACT_APP_URL_DEV;

const FormFormateur = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    cv: null,
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const recaptchaWidgetId = useRef(null);

  const onCaptchaChange = (token) => {
    setCaptchaToken(token);
    setErrors((prev) => ({ ...prev, captcha: '' }));
  };

  useEffect(() => {
    const loadRecaptcha = () => {
      if (window.grecaptcha && window.grecaptcha.render) {
        recaptchaWidgetId.current = window.grecaptcha.render(
          'recaptcha-container',
          {
            sitekey: siteKey,
            callback: onCaptchaChange,
          },
        );
      }
    };

    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = loadRecaptcha;
      document.body.appendChild(script);
    } else {
      loadRecaptcha();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'file' ? files[0] : value,
    });
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = 'Ce champ est obligatoire.';
    if (!formData.lastName.trim())
      newErrors.lastName = 'Ce champ est obligatoire.';
    if (!formData.email.trim()) {
      newErrors.email = 'Ce champ est obligatoire.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Adresse email invalide.';
    }
    if (!formData.phone.trim()) newErrors.phone = 'Ce champ est obligatoire.';
    if (!formData.cv) newErrors.cv = 'Ce champ est obligatoire.';
    if (!captchaToken) newErrors.captcha = 'Veuillez valider le CAPTCHA.';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSuccess('');
      return;
    }

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append('g-recaptcha-response', captchaToken);

    try {
      const response = await axios.post(`${Url}/api/form/Form`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log('Réponse du serveur:', response.data);
      setSuccess('Formulaire soumis avec succès !');
      setErrors({});
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        cv: null,
        message: '',
      });
      setCaptchaToken('');
      if (window.grecaptcha && recaptchaWidgetId.current !== null) {
        window.grecaptcha.reset(recaptchaWidgetId.current);
      }
    } catch (error) {
      console.error('Erreur lors de la soumission du formulaire:', error);
      setSuccess('');
      setErrors({ captcha: "Erreur lors de l'envoi, veuillez réessayer." });
    }
  };

  return (
    <div className="formateur-container">
      <h2>Espace formateur</h2>
      {success && <p className="success-message">{success}</p>}
      <form className="formateur-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="firstName"
          placeholder="Prénom *"
          className="form-control"
          value={formData.firstName}
          onChange={handleChange}
        />
        {errors.firstName && (
          <p className="error-message">{errors.firstName}</p>
        )}

        <input
          type="text"
          name="lastName"
          placeholder="Nom *"
          className="form-control"
          value={formData.lastName}
          onChange={handleChange}
        />
        {errors.lastName && <p className="error-message">{errors.lastName}</p>}

        <input
          type="email"
          name="email"
          placeholder="Email *"
          className="form-control"
          value={formData.email}
          onChange={handleChange}
        />
        {errors.email && <p className="error-message">{errors.email}</p>}

        <PhoneInput
          country={'tn'}
          value={formData.phone}
          name="phone"
          onChange={(value) => {
            setFormData({ ...formData, phone: value });
            setErrors((prev) => ({ ...prev, phone: '' }));
          }}
          placeholder="N° téléphone *"
          inputStyle={{ width: '100%', height: '42px' }}
        />
        {errors.phone && <p className="error-message">{errors.phone}</p>}

        <label className="file-upload-label">
          Télécharger CV *
          <input
            type="file"
            name="cv"
            className="file-upload-input"
            onChange={handleChange}
          />
        </label>
        {errors.cv && <p className="error-message">{errors.cv}</p>}

        <textarea
          name="message"
          placeholder="Message"
          className="form-control"
          rows="4"
          value={formData.message}
          onChange={handleChange}
        ></textarea>

        {/* CAPTCHA */}
        <div id="recaptcha-container" style={{ margin: '15px 0' }}></div>
        {errors.captcha && <p className="error-message">{errors.captcha}</p>}

        <center>
          <button type="submit">Envoyer</button>
        </center>
      </form>
    </div>
  );
};

export default FormFormateur;
